module.exports = __webpack_public_path__ + "static/media/write.7e0ea44e.jpg";